import { Position } from "@blueprintjs/core"
import React from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import { useAuthorizationSimple } from "hooks/useAuthorizationStrict"
const NewOrderActions = props => {
  const navigate = useNavigate()

  const selectedOrders = useSelector(state => {
    const selected = state.selector?.orders?.selected
    return selected ? Object.keys(selected) : []
  })

  const canAddResource = useAuthorizationSimple(`ds_add_order`)
  function handleClick(type) {
    switch (type) {
      case "order":
        navigate("/d/ecom/orders/add/new")
        return
      case "consolidated":
        const orders = btoa(selectedOrders.join(","))
        navigate(
          `/d/ecom/orders/add/new-consolidated?ords=${orders}&total=${
            props?.count || 0
          }`
        )
        return
      default:
        return
    }
  }

  return (
    <>
      <ActionMenu
        onClick={handleClick}
        popoverProps={{
          position: Position.BOTTOM_RIGHT,
        }}
        text="New"
        icon="plus"
        rightIcon="caret-down"
        dark={true}
        {...props}
      >
        <ActionMenuItem disabled={!canAddResource} text="Order" id="order" />
        <ActionMenuItem
          disabled={!canAddResource}
          text="Consolidated order"
          id="consolidated"
        />
      </ActionMenu>
    </>
  )
}

export default NewOrderActions
